export const cart = {
    title: 'Carrito',
    empty: 'Tu carrito está vacío',
    emptyDescription: 'Añade productos al carrito para continuar',
    continueShopping: 'Continuar comprando',
    checkout: 'Hablar con vendedor',
    items: 'artículos',
    item: 'artículo',
    removeItem: 'Eliminar artículo',
    updateQuantity: 'Actualizar cantidad',
    decreaseQuantity: 'Disminuir cantidad',
    increaseQuantity: 'Aumentar cantidad',
    close: 'Cerrar carrito',
    subtotal: 'Subtotal',
    shipping: 'Envío',
    discount: 'Descuento',
    total: 'Total',
    estimatedShipping: 'Envío estimado',
    freeShipping: 'Envío gratis',
    minForFreeShipping: 'Faltan {{amount}} para envío gratis',
};
//# sourceMappingURL=cart.js.map